import { render, staticRenderFns } from "./UpdateBulkModal.vue?vue&type=template&id=38903586"
import script from "./UpdateBulkModal.vue?vue&type=script&lang=js"
export * from "./UpdateBulkModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateBulkModal.vue?vue&type=style&index=0&id=38903586&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports